import { render, staticRenderFns } from "./UserProgressPercentageDoughnutChart.vue?vue&type=template&id=47503c2b&"
import script from "./UserProgressPercentageDoughnutChart.vue?vue&type=script&lang=ts&"
export * from "./UserProgressPercentageDoughnutChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports